// extracted by mini-css-extract-plugin
export var root = "video-player-module--root--31b0c";
export var rounded = "video-player-module--rounded--06335";
export var roundedTop = "video-player-module--roundedTop--76dcf";
export var roundedTopMed = "video-player-module--roundedTopMed--61455";